import { env } from '@/env';
import type { PermHiddenFunctionContentResponse } from '@/models/interface/function.dto';
import { ApiFactory } from '@/utils/api';

const baseUrl: string = env.apiBaseUrlNoVersion;

export class FunctionV2Service extends ApiFactory {
  constructor() {
    super(baseUrl);
  }

  /**
   * 取得 隱藏的功能列表 (訂閱/旁聽)
   * @param options - API 請求選項
   */
  getHiddenFunctionAccess(): Promise<PermHiddenFunctionContentResponse> {
    return super.get('v2/Function/HiddenFunction');
  }
}
